import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  change(event) {
    Turbo.visit(event.target.value);
  }
}
